import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { VerifyBanner } from "@/components/VerifyBanner";
import { Loading, EmptyState } from "@/components/States";
import { useAuth } from "@/context/AuthContext";
import { Handshake, MapPin, ArrowRight } from "lucide-react";

export default function Matches() {
  const { user } = useAuth();
  const [items, setItems] = useState(null);
  useEffect(() => { if (user?.email_verified) api.get("/matches").then((r) => setItems(r.data)).catch(() => setItems([])); else setItems([]); }, [user]);

  return (
    <div>
      <h1 className="font-display text-3xl font-bold text-[#F8FAFC]">Match</h1>
      <p className="mt-1 text-[#CBD5E1]">Corrispondenze reciproche basate sulle vostre liste. Non indicano un'equivalenza di valore tra le carte.</p>
      <div className="mt-6"><VerifyBanner /></div>

      {items === null ? <Loading /> : items.length === 0 ? (
        <EmptyState icon={Handshake} title="Nessuna corrispondenza reciproca" description="Un match esiste quando tu possiedi una carta che l'altra persona cerca e viceversa. Aggiungi carte e completa la wishlist per aumentare le possibilità."
          action={<Link to="/wishlist" className="rounded-lg bg-[#7C3AED] px-4 py-2 text-sm text-white hover:bg-[#6D28D9]">Completa la wishlist</Link>} />
      ) : (
        <div className="mt-2 space-y-3" data-testid="matches-list">
          {items.map((m) => (
            <Link key={m.user.id} to={`/match/${m.user.id}`} data-testid="match-row" className="card-lift flex items-center justify-between rounded-2xl border border-[#2A3655] bg-[#141B2D] p-4">
              <div className="flex items-center gap-4">
                <span className="grid h-12 w-12 place-items-center rounded-full bg-[#7C3AED] text-lg font-bold text-white">{m.user.username[0].toUpperCase()}</span>
                <div>
                  <p className="font-display font-semibold text-[#F8FAFC]">@{m.user.username}</p>
                  <div className="mt-1 flex flex-wrap items-center gap-2 text-xs">
                    <span className="rounded-md border border-[#2DD4BF]/30 bg-[#2DD4BF]/10 px-2 py-0.5 font-semibold text-[#2DD4BF]" data-testid="match-you-have">Hai {m.you_have_they_want} {m.you_have_they_want === 1 ? "carta" : "carte"} che cerca</span>
                    <span className="rounded-md border border-[#7C3AED]/30 bg-[#7C3AED]/10 px-2 py-0.5 font-semibold text-[#a78bfa]" data-testid="match-they-have">Ha {m.they_have_you_want} {m.they_have_you_want === 1 ? "carta" : "carte"} che cerchi</span>
                    {m.same_province && m.user.province && <span className="flex items-center gap-1 text-[#94A3B8]"><MapPin className="h-3 w-3" />{m.user.province}</span>}
                  </div>
                </div>
              </div>
              <ArrowRight className="h-5 w-5 text-[#94A3B8]" />
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
